import React from "react";

/** 认证页共用卡片外壳：品牌块 + 标题 + 表单内容。 */
export default function AuthCard({ title, subtitle, children }) {
  return (
    <div className="lt-auth">
      <div className="lt-auth-card">
        <div className="lt-auth-brand">
          <img src={`${process.env.PUBLIC_URL}/logo192.png`} alt="边角聊 logo" />
          <span className="t">
            <b>边角聊</b>
            <span>LEFTOVER TALK</span>
          </span>
        </div>
        {title ? (
          <div>
            <h1 className="lt-auth-title">{title}</h1>
            {subtitle ? <p className="lt-auth-sub">{subtitle}</p> : null}
          </div>
        ) : null}
        {children}
      </div>
    </div>
  );
}
